import styled, { css } from 'styled-components';
import { safeGap } from '../../styles/mixins';

export const CARDS_BEFORE_BANNER = { mobile: 2, tablet: 5, bigDesktop: 7 };

const BANNER_ORDER_RULES = [
  { media: `(max-width: 767px)`, cardsBeforeBanner: CARDS_BEFORE_BANNER.mobile },
  { media: `(min-width: 768px) and (max-width: 1239px)`, cardsBeforeBanner: CARDS_BEFORE_BANNER.tablet },
  { media: `(min-width: 1240px)`, cardsBeforeBanner: CARDS_BEFORE_BANNER.bigDesktop },
];

export const CityCardsGridStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  ${safeGap('16px')};

  .openx-adv-banner {
    width: 100%;
  }

  ${BANNER_ORDER_RULES.map(
    ({ media, cardsBeforeBanner }) => css`
      @media ${media} {
        .openx-ui-card:nth-child(n + ${cardsBeforeBanner + 1}) {
          order: 1;
        }
      }
    `
  )}

  .flex-unsupported & {
    @media (max-width: 767px) {
      > * {
        margin-left: 0;
      }
    }

    @media (min-width: 768px) and (max-width: 1239px) {
      .openx-ui-tile-1,
      .openx-ui-tile-4,
      .openx-ui-tile-6,
      .openx-ui-tile-8,
      .openx-ui-tile-10,
      .openx-ui-tile-13,
      .openx-ui-tile-15 {
        margin-left: 0;
      }
    }

    @media (min-width: 1240px) {
      .openx-ui-tile-1,
      .openx-ui-tile-5,
      .openx-ui-tile-8,
      .openx-ui-tile-11,
      .openx-ui-tile-14 {
        margin-left: 0;
      }
    }
  }
`;
